import type { CSSProperties } from "react";
import {
  Settings, Camera, ScanLine, Plus, X, Check,
  ChevronRight, ChevronDown, ArrowRight, ArrowLeft,
  Trash2, User, Receipt, Calendar, Sparkles, Bell, Info,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

export type IcoName =
  | "settings" | "cam" | "scan" | "plus" | "close" | "check" | "chev"
  | "chevDown" | "arrow" | "arrowL" | "trash" | "user" | "receipt"
  | "calendar" | "spark" | "bell" | "info";

const map: Record<IcoName, LucideIcon> = {
  settings: Settings,
  cam: Camera,
  scan: ScanLine,
  plus: Plus,
  close: X,
  check: Check,
  chev: ChevronRight,
  chevDown: ChevronDown,
  arrow: ArrowRight,
  arrowL: ArrowLeft,
  trash: Trash2,
  user: User,
  receipt: Receipt,
  calendar: Calendar,
  spark: Sparkles,
  bell: Bell,
  info: Info,
};

interface Props {
  name: IcoName;
  size?: number;
  color?: string;
  stroke?: number;
  style?: CSSProperties;
}

export function Ico({ name, size = 20, color = "currentColor", stroke = 1.5, style }: Props) {
  const I = map[name];
  return (
    <I
      size={size}
      color={color}
      strokeWidth={stroke}
      style={{ display: "block", ...style }}
    />
  );
}
